module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "img3"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Image",
      "src": "images/dot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fmh2"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "htt",
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "htt",
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_vm._v("CHAPTER 1: MORNiNG WAKE-UP TO EVENING INDULGENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "htt",
    attrs: {
      "href": "#/xhtml/Chapter02"
    }
  }, [_vm._v("CHAPTER 2: MANAGING DiSEASE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "htt",
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3: MANAGING WELL-BEiNG")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "htt",
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4: MANAGING BEAuTY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "htt",
    attrs: {
      "href": "#/xhtml/Chapter04_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overhaul Your Look")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "htt",
    attrs: {
      "href": "#/xhtml/Chapter04_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overhaul Your Cosmetics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc5"
  }, [_c('span', {
    staticClass: "htt",
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0